import * as consts from './MapConsts';

const initialState = {
    location: {
        lat: 0,
        lng: 0
    },
    mapInfo: {
        zoom: 0,
        type: 'roadmap',
        defaultStreetView: true
    },
    getTourFulfilled: false,
    getCoordinatesPending: false,
    getCoordinatesError: ''
    
};

const map = (state = initialState, action) => {
    switch (action.type) {
        case consts.GET_COORDINATES_PENDING:
            return {
                ...state,
                getCoordinatesPending: true
            }
        case consts.GET_COORDINATES_FULFILLED:
            return {
                ...state,
                location: action.payload.location,
                getCoordinatesPending: false
            }
        case consts.GET_COORDINATES_REJECTED:
            return {
                ...state,
                getCoordinatesError: action.payload
            }
        default:
            return state
    }
}

export default map;
